export function initProgressPlugin() {
    const hasProgressComponents = document.querySelector('.js-progress-animate');

    if (hasProgressComponents) {
        // Dynamic Import: carica il file solo ora
        import('./progress_animations.js')
            .then(module => {
                // Esegue la funzione default esportata dal modulo
                module.default();
            })
            .catch(err => {
                console.error('Errore nel caricamento del plugin Progress:', err);
            });
    }
}
